import React from "react";

/**
 * Currently useless TODO
 * @param props
 */
export const WASearch: React.FC<{}> = () => (
  <form className="wa-header-search">
    <div className="search py-2">
      <input
        type="text"
        className="search-input"
        placeholder="Example Input Placeholder"
      />
      <div className="search-icon-wrapper">
        <div className="search-icon"></div>
      </div>
    </div>
  </form>
);
